export default "__VITE_ASSET__BInZfLNG__"